import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_193: DocMigration = {
  maxSchemaVersion: "0.0.193",
  description: "Migrate roof fasciaSize to rakeFasciaSize and eaveFasciaSize",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];

      if (setting.type !== "ROOF_SETTINGS" || setting.fasciaSize === undefined) {
        continue;
      }

      setting.eaveFasciaSize = setting.fasciaSize;
      setting.rakeFasciaSize = setting.fasciaSize;

      delete setting.fasciaSize;

      json.settings[settingId] = setting;
    }
    return json;
  },
};

export default migration_0_0_193;
